<template>
  <!-- role 속성은 웹 접근성에 필요할 경우 넣는 속성이므로 swiper의 필수값은 아닙니다 -->
  <swiper :options="swiperOption">
    <swiper-slide v-for="(banner, idx) in exBannerFiles" :key="idx">
      <img :src="banner.file_path" />
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapGetters } from "vuex";

export default {
  name: "BannerSwiper",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1, // 한 번에 하나의 슬라이드만 보여줌
        spaceBetween: 6,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

        centerInsufficientSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },

  computed: {
    ...mapGetters(["getObituaryFuneral"]),
    exBannerFiles() {
      const customFiles = this.getObituaryFuneral?.FuneralCustomFiles;
      if (!customFiles) {
        return null;
      }
      if (customFiles && customFiles?.length !== 0) {
        const bannerFile = customFiles.filter((v) => v.custom_type == 2);

        return bannerFile;
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  .swiper-wrapper {
    .swiper-slide img {
      width: 100%;
    }
  }
}
</style>
<style>
.swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.757);
}
.swiper-pagination .swiper-pagination-bullet-active {
  opacity: 1;
  background: rgb(26, 131, 235);
}

.swiper-pagination {
  /* background-color: rgba(255, 255, 255, 0.609); */
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content !important;
  height: 18px;
  padding: 0 4px;
  border-radius: 50px;
  bottom: 10px !important;
  right: 0;
  margin: auto;
}
</style>
